import { useCallback, useEffect } from 'react';
import { loadPostAsync } from '../../data-layer/posts/actions';
import { selectPostById } from '../../data-layer/posts/selectors';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import type { PostModel } from '../../data-layer/posts/types';

interface UsePostControllerParams {
    postId?: string;
}

export const usePostModel = (params: UsePostControllerParams): PostModel | undefined => {
    const { postId } = params;
    const dispatch = useDispatch();
    const model = useSelector((state) => selectPostById(state, postId));
    const onLoadPost = useCallback(
        (targetId: string) => dispatch(loadPostAsync(targetId)),
        [dispatch],
    );

    useEffect(() => {
        if (postId && !model) {
            onLoadPost(postId);
        }
    }, [model, postId, onLoadPost]);

    return model;
};
